import { render, staticRenderFns } from "./KamItemVerificationDetail.vue?vue&type=template&id=5d755e23&"
import script from "./KamItemVerificationDetail.vue?vue&type=script&lang=js&"
export * from "./KamItemVerificationDetail.vue?vue&type=script&lang=js&"
import style0 from "./KamItemVerificationDetail.vue?vue&type=style&index=0&id=5d755e23&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports